/**
 * Напольная сантехника на плане: унитаз, ванна, душ, стиральная и сушильная машины.
 *
 * Как и мебель, рисуется одним символом, залитым по своему контуру, без квадратной подложки; выделение —
 * синий цвет символа и пунктир по габариту. Рисуется в локальных координатах предмета,
 * поворот и перенос делает вызывающий.
 */
import type { PointerEvent } from "react";
import { itemDimensions, type FloorItem } from "@/shared/plan";
import type { CatalogItem } from "@/shared/catalog";
import { CatalogSymbol } from "../../CatalogSymbol";

/** Габариты, если типа в каталоге больше нет — объект всё равно виден и удаляем. */
const MISSING = { width: 600, depth: 600, color: "#9aa3b2" };

interface Props {
	item: FloorItem;
	/** Тип из каталога; null — тип удалён из каталога */
	info: CatalogItem | null;
	selected: boolean;
	mmPerPx: number;
	interactive?: boolean;
	onPointerDown?: (e: PointerEvent<SVGGElement>) => void;
}

export const PlumbingFloorShape = ({
	item,
	info,
	selected,
	mmPerPx,
	interactive = true,
	onPointerDown,
}: Props) => {
	const size = info ? itemDimensions(item, info) : MISSING;
	const w = size.width;
	const d = size.depth;
	const px = (n: number) => n * mmPerPx;
	const color = selected ? "#2f6feb" : "#4a5568";

	return (
		<g
			onPointerDown={onPointerDown}
			style={{
				cursor: interactive ? "move" : "default",
				pointerEvents: interactive ? "auto" : "none",
			}}
		>
			<CatalogSymbol item={info} width={w} height={d} color={color} mmPerPx={mmPerPx} />
			{/* Выделение: символ уже синий, добавляем тонкий штрих по габариту */}
			{selected && (
				<rect
					x={-w / 2}
					y={-d / 2}
					width={w}
					height={d}
					fill="none"
					stroke={color}
					strokeWidth={px(0.9)}
					strokeDasharray={`${px(4)} ${px(3)}`}
				/>
			)}
			{/* Зона захвата поверх символа — иначе предмет берётся только за линии рисунка */}
			<rect
				data-role="item"
				data-id={item.id}
				x={-w / 2}
				y={-d / 2}
				width={w}
				height={d}
				fill="transparent"
			/>
		</g>
	);
};
